var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.conversionRates)?_c('b-table',{ref:"conversionRates",attrs:{"outlined":"","striped":"","items":_vm.conversionRates,"fields":_vm.conversionRatesFields}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }